/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { boxShadows, functions, transitions, palette } = theme;
  const { openConfigurator } = ownerState;

  const configuratorWidth = 360;
  const { gradients, info, white } = palette;
  const { lg } = boxShadows;
  const { pxToRem, linearGradient } = functions;

  // drawer styles when openConfigurator={true}
  const drawerOpenStyles = () => ({
    width: configuratorWidth,
    maxWidth: '100%',
    //left: "initial",
    //right: 0,
    display: 'block',
    transition: transitions.create("display", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.short,
    }),
  });

  // drawer styles when openConfigurator={false}
  const drawerCloseStyles = () => ({
    display: 'none',
    //left: "initial",    
    //right: pxToRem(-350),
    transition: transitions.create("all", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.short,
    }),
  });
  return {    
    "& .MuiDrawer-paper": {
      //backdropFilter: `blur(${pxToRem(42)})`,
      // background: linearGradient(
      //   gradients.sidenav.main,
      //   gradients.sidenav.state,
      //   gradients.sidenav.deg
      // ),
      background: '#f9f9f9',
      height: "auto",
      margin: '70px auto 0',
      padding: `0 ${pxToRem(10)} 20px`,
      borderRadius: 12,
      boxShadow: lg,
      overflowY: "inherit",
      position: 'static',
      top: 'inherit',
      left: 'inherit',
      transform: 'none',
      flex: 'none',
      whiteSpace: 'normal',
      ...(openConfigurator ? drawerOpenStyles() : drawerCloseStyles()),
    },
  };
});
